<!-- 基金持仓图例 -->
<template>
  <div class="fund-hold-legend">
    <div v-for="(item, index) in dataSource.slice(0, 4)" :key="index" class="legend-item row">
      <div class="title row">
        <div class="dot" :style="{ backgroundColor: item.color || '#ffffff'}"></div>
        <div class="type">{{item.type}}</div>
      </div>
      <div class="value">{{`${parseFloat(item.percent * 100).toFixed(2)}%` || '--'}}</div>
    </div>
    <div v-if="dataSource.length > 4" class="more" @click="$goFundApp"
      >{{ moreText }}</div>
    <div v-if="isMoreThanHundred" class="more" @click="$goFundApp"
      >为什么比例超过100%</div>
  </div>
</template>

<script>
export default {
  name: 'fund-hold-legend',

  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    curTab: {
      type: Object,
      default: () => ({}),
    },
    isMoreThanHundred: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    moreText() {
      console.log(this.curTab);
      const title = this.curTab.value === 'classify' ? '基金类型' : this.curTab?.name || '';
      return `更多${title}分布`;
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fund-hold-legend {
  width: 280px;
  min-height: 240px;
  margin-left: 30px;
  .legend-item {
    justify-content: space-between;
    margin-top: 16px;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      color: #000000;
      line-height: 42px;
      .dot {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        margin-right: 16px;
      }
      .type {
        flex: 1;
      }
    }
    .value {
      font-family: DINAlternate-Bold;
      font-size: 28px;
      color: #000000;
      line-height: 28px;
    }
  }
  .more {
    font-size: 28px;
    color: #3A90FA;
    margin-top: 24px;
  }
}
</style>
